var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "learning-path": true,
        container: !_vm.isMobile(_vm.$mq),
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("div", { staticClass: "details" }, [
        _c("h2", [_vm._v("Learning Path")]),
        _vm._v(" "),
        _c(
          "h1",
          [
            _vm._v("\n      " + _vm._s(_vm.learningPath.name) + "\n      "),
            _vm.learningPathAdminMenu && !_vm.isMobile(_vm.$mq)
              ? _c("AdminMenu", {
                  attrs: {
                    items: _vm.learningPathAdminMenu.items,
                    badges: _vm.learningPathAdminMenu.badges,
                    orientation: ["top", "left"]
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "description",
          domProps: { innerHTML: _vm._s(_vm.learningPath.description) }
        }),
        _vm._v(" "),
        !_vm.isMobile(_vm.$mq)
          ? _c(
              "p",
              {
                directives: [
                  {
                    name: "track",
                    rawName: "v-track:click",
                    value: {
                      axId: "clicked_back_to_courses_from_learning_path",
                      axType: "link",
                      axExtra: {
                        learning_path_id: _vm.learningPath.learning_path_id,
                        learning_path_name: _vm.learningPath.name
                      }
                    },
                    expression:
                      "{\n        axId: 'clicked_back_to_courses_from_learning_path',\n        axType: 'link',\n        axExtra: {\n          learning_path_id: learningPath.learning_path_id,\n          learning_path_name: learningPath.name,\n        },\n      }",
                    arg: "click"
                  }
                ],
                staticClass: "back"
              },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "explorations_menu", hash: "#learning-paths" }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "b-sprite-courses-chevron-1-black"
                    }),
                    _vm._v("\n        Back to all courses\n      ")
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "groups" },
        _vm._l(_vm.learningGroups, function(group) {
          return _c("section", { key: group.group_id }, [
            _c(
              "h3",
              [
                _vm._v("\n        " + _vm._s(group.name) + "\n        "),
                _vm.groupAdminMenu(group) && !_vm.isMobile(_vm.$mq)
                  ? _c("AdminMenu", {
                      attrs: {
                        items: _vm.groupAdminMenu(group).items,
                        badges: _vm.groupAdminMenu(group).badges,
                        orientation: ["top", "right"]
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            group.linked
              ? _c(
                  "ol",
                  _vm._l(group.courses, function(course, index) {
                    return _c("CourseItem", {
                      key: group.learning_group_id + "-" + course.course_id,
                      staticClass: "course-item",
                      attrs: {
                        "learning-path": _vm.learningPath,
                        course: course,
                        "course-number": index + 1
                      }
                    })
                  }),
                  1
                )
              : _c(
                  "ul",
                  _vm._l(group.courses, function(course) {
                    return _c("CourseItem", {
                      key: group.learning_group_id + "-" + course.course_id,
                      staticClass: "course-item",
                      attrs: {
                        "learning-path": _vm.learningPath,
                        course: course
                      }
                    })
                  }),
                  1
                )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }